import React from 'react'
import { LoanCalculatorContext } from 'modules/react/loan-calculator/LoanCalculatorContainer'

const DisclaimerText = () => {
  const { modalText } = React.useContext(LoanCalculatorContext)

  return (
    modalText?.disclaimer ? (
      <div
        className='lc-disclaimer'
        dangerouslySetInnerHTML={{__html: modalText.disclaimer}}
      />
    ) : null
  )
}

export default DisclaimerText
